import baseAxios from '@/services/axios_base.js'

export const useKeycloakService = () => {
  const baseurl = useRuntimeConfig().public.BASIC_API_URL || 'https://apim-enext-stg.azure-api.net'

  const auth_axios = baseAxios.create({
    baseURL: useRuntimeConfig().public.AUTH_API || baseurl
  })

  const exchangeKeycloakCode = async function(customerUuid: string | null, authorizationCode: string, codeVerifier: string, redirectUri: string) {
    let sanitizedCustomerUuid = customerUuid
    if (!sanitizedCustomerUuid) {
      sanitizedCustomerUuid = 'default'
    }
    return auth_axios.post(`/1.0.0/${sanitizedCustomerUuid}/auth/keycloak/code`, {
      code: authorizationCode,
      codeVerifier: codeVerifier,
      redirectUri: redirectUri
    })
  }

  const switchKeycloakCustomer = async function(customerUuid: string | null, accessToken: string) {
    let sanitizedCustomerUuid = customerUuid
    if (!sanitizedCustomerUuid) {
      sanitizedCustomerUuid = 'default'
    }
    return auth_axios.post(`/1.0.0/${sanitizedCustomerUuid}/auth/keycloak/code`, {
      accessToken: accessToken
    })
  }

  return {
    exchangeKeycloakCode,
    switchKeycloakCustomer
  }
}
